/* UROPEUROPE — Scroll-Effekte (Header, Parallax, Reveals, Brand-Block) */
(function () {
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Header: transparent über dem Hero (Startseite), solide ab Scroll */
  var header = document.querySelector(".site-header");
  var isIndex = document.body.classList.contains("template-index");
  if (header && isIndex) {
    var updateHeader = function () {
      header.classList.toggle("is-overlay", window.scrollY <= 40);
    };
    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });
  }

  /* Hamburger: Mobile-Menü auf-/zuklappen */
  var menuToggle = document.querySelector(".menu-toggle");
  if (menuToggle && header) {
    menuToggle.addEventListener("click", function () {
      var open = header.classList.toggle("menu-open");
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* Produktgalerie: Thumbnail scrollt zum Bild, Scrollspy markiert das aktive */
  var thumbs = document.querySelectorAll(".product-gallery__thumb");
  var galleryItems = document.querySelectorAll(".product-gallery__item");
  if (thumbs.length && galleryItems.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var target = document.getElementById(thumb.getAttribute("data-target"));
        if (target) {
          target.scrollIntoView({
            behavior: reduced ? "auto" : "smooth",
            block: "center"
          });
        }
      });
    });
    var setActiveThumb = function (id) {
      thumbs.forEach(function (t) {
        t.classList.toggle("is-active", t.getAttribute("data-target") === id);
      });
    };
    if ("IntersectionObserver" in window) {
      var spy = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActiveThumb(entry.target.id);
          });
        },
        { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
      );
      galleryItems.forEach(function (item) { spy.observe(item); });
    }
  }

  /* Mobile Wisch-Galerie: Punkte synchron halten und anklickbar machen */
  var galleryTrack = document.querySelector(".product-gallery");
  var dots = document.querySelectorAll(".product-gallery__dot");
  if (galleryTrack && dots.length) {
    var syncDots = function () {
      var index = Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    };
    galleryTrack.addEventListener("scroll", syncDots, { passive: true });
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var i = parseInt(dot.getAttribute("data-index"), 10);
        galleryTrack.scrollTo({
          left: i * galleryTrack.clientWidth,
          behavior: reduced ? "auto" : "smooth"
        });
      });
    });
  }

  if (reduced) return;

  /* Reveals */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("reveal-visible"); });
  }

  /* Loop-Helfer: rAF nur solange Element sichtbar, plus Scroll-Fallback */
  function scrollScene(el, update) {
    var raf = 0;
    var tick = function () { update(); raf = requestAnimationFrame(tick); };
    var onScroll = function () { update(); };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (!raf) raf = requestAnimationFrame(tick);
        } else if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      }).observe(el);
    }
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  function clamp01(v) { return Math.min(1, Math.max(0, v)); }
  function easeOut(p) { return 1 - Math.pow(1 - p, 3); }

  /* Hero-Parallax + Content-Fade */
  var hero = document.querySelector(".hero");
  if (hero) {
    var media = hero.querySelector(".hero__media");
    var content = hero.querySelector(".hero__content");
    var lastTop = NaN;
    scrollScene(hero, function () {
      var rect = hero.getBoundingClientRect();
      if (rect.top === lastTop) return;
      lastTop = rect.top;
      var offset = rect.top + rect.height / 2 - window.innerHeight / 2;
      if (media) {
        /* Verschiebung hart begrenzen — der Überstand in base.css ist 32 %,
           mehr als 28 % würde unten eine Lücke aufreißen. */
        var maxShift = rect.height * 0.28;
        var shift = offset * 0.25;
        if (shift > maxShift) shift = maxShift;
        if (shift < -maxShift) shift = -maxShift;
        media.style.transform = "translate3d(0," + shift.toFixed(1) + "px,0)";
      }
      if (content) {
        var y = window.scrollY;
        var fadeStart = window.innerHeight * 0.2;
        var fadeRange = window.innerHeight * 0.8;
        var fade = 1 - Math.max(0, y - fadeStart) / fadeRange;
        content.style.opacity = Math.max(0, fade).toFixed(3);
        content.style.transform = "translate3d(0," + (y * 0.08).toFixed(1) + "px,0)";
      }
    });
  }

  /* Brand-Block: gepinnte Logo-Szene */
  var brand = document.querySelector(".brand-block");
  if (brand) {
    var logo = brand.querySelector(".brand-block__logo");
    var tagline = brand.querySelector(".brand-block__tagline");
    var lastBTop = NaN;
    scrollScene(brand, function () {
      var rect = brand.getBoundingClientRect();
      if (rect.top === lastBTop) return;
      lastBTop = rect.top;
      var total = rect.height - window.innerHeight;
      if (total <= 0) return;
      var p = clamp01(-rect.top / total);
      if (logo) {
        var logoP = easeOut(clamp01(p * 1.6));
        logo.style.opacity = clamp01(p * 2.4).toFixed(3);
        logo.style.transform = "scale(" + (0.72 + logoP * 0.28).toFixed(4) + ")";
      }
      if (tagline) {
        var tagP = easeOut(clamp01((p - 0.42) * 2.6));
        tagline.style.opacity = tagP.toFixed(3);
        tagline.style.transform = "translate3d(0," + ((1 - tagP) * 26).toFixed(1) + "px,0)";
      }
    });
  }
})();
